import { DeviceType } from '@/app/components/DeviceSelectionGallery/DeviceSelectionGallery.types'
import { DeviceLimits } from './programs-new'
import { match } from 'ts-pattern'

function deviceLimitKeyToDeviceType(
  key: keyof DeviceLimits,
): DeviceType | undefined {
  return match(key)
    .with('vehicle', () => 'vehicle')
    .with('thermostat', () => 'thermostat')
    .with('charger', () => 'vehicleCharger')
    .with('energy_system', () => 'energySystem')
    .with('behavioral', () => undefined)
    .with('total_devices', () => undefined)
    .exhaustive() as DeviceType | undefined
}

/**
 * Returns the device types that are eligible for the program based on the device limits.
 * The device type is eligible if the device limit is not null.
 */
export function elibleDeviceTypesFromLimits(
  deviceLimits: DeviceLimits,
): DeviceType[] {
  const eligibleDeviceTypes: DeviceType[] = []
  for (const deviceLimitKey of Object.keys(
    deviceLimits,
  ) as (keyof DeviceLimits)[]) {
    if (deviceLimitKey === 'total_devices' || deviceLimitKey === 'behavioral') {
      continue
    }
    if ((deviceLimits[deviceLimitKey] ?? null) !== null) {
      const deviceType = deviceLimitKeyToDeviceType(deviceLimitKey)
      if (deviceType) {
        eligibleDeviceTypes.push(deviceType)
      }
    }
  }
  return eligibleDeviceTypes
}

/**
 * Returns the device types that are required for the program based on the device limits.
 * The device type is required if the device limit min is greater than 0.
 */
export function requiredDeviceTypesFromLimits(
  deviceLimits: DeviceLimits,
): DeviceType[] {
  const requiredDeviceTypes: DeviceType[] = []
  for (const deviceLimitKey of Object.keys(
    deviceLimits,
  ) as (keyof DeviceLimits)[]) {
    if (deviceLimitKey === 'total_devices' || deviceLimitKey === 'behavioral') {
      continue
    }
    if ((deviceLimits[deviceLimitKey]?.min ?? 0) > 0) {
      const deviceType = deviceLimitKeyToDeviceType(deviceLimitKey)
      if (deviceType) {
        requiredDeviceTypes.push(deviceType)
      }
    }
  }
  return requiredDeviceTypes
}
